import React from "react";
import {
    TableCell,
    TableRow,
    Box,
    Grid,
    Collapse,
} from '@mui/material';
import dayjs from 'dayjs';
import GlobalProps from "../../../core/BaseComponents/TableWrapper/Global";

const HotelListSummary = (props) => {
    const { row, columns, open } = props;

    return <TableRow>
        <TableCell style={{ padding: 0, margin: 0, border: 0 }} colSpan={columns.length + 1}>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box className={'row-details'} padding={2} paddingTop={4} paddingBottom={3} style={{ backgroundColor: "#eceef8" }} >
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item container spacing={0} xs={12} className='grid-block-section'>
                            <Grid item xs={props?.module==="stack-details"?3:4}>
                                <div className='row-summary-title'>Created By</div>
                                <div className='row-summary-value'>{row.createdBy ? row.createdBy : "N.A"}</div>
                            </Grid>
                            {(props?.module === "hotel-config" || props?.module==="stack-details") && <Grid item xs={props?.module==="stack-details"?3:4}>
                                <div className='row-summary-title'>Created Date</div>
                                <div className='row-summary-value'>{row.createdOn ? `${dayjs(row.createdOn).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.createdOn).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                            </Grid>}
                            <Grid item xs={props?.module==="stack-details"?3:4}>
                                <div className='row-summary-title'>Modified By</div>
                                <div className='row-summary-value'>{row.modifiedBy ? row.modifiedBy : "N.A"}</div>
                            </Grid>
                            <Grid item xs={props?.module==="stack-details"?3:4} className={`${props?.module === "hotel-config" ? 'mt-3' : ''}`} >
                                <div className='row-summary-title'>Modified Date</div>
                                <div className='row-summary-value'>{row.modifiedOn ? `${dayjs(row.modifiedOn).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.modifiedOn).format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                            </Grid>
                            {props.module === 'hotel-config' && <><Grid item xs={4} className="mt-3">
                                <div className='row-summary-title'>Location</div>
                                <div className='row-summary-value'>{row.address ? row.address : "N.A"}</div>
                            </Grid>
                                {/* <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Room {row.roomType?.length === 1 ? "Type" : "Types"}</div>
                                    <div className='row-summary-value'>{row.roomType?.length ? row?.roomType?.map((item, index) => <span key={index}>{index ? ', ' : ''}{item}</span>) : "N.A"}</div>
                                </Grid>  */}
                                </>}
                            {props.module === "banner-config" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Room {row.roomTypes?.length === 1 ? "Type" : "Types"} </div>
                                    <div className='row-summary-value'>{row.roomTypes?.length ? row?.roomTypes?.map((item, index) => <span key={index}>{index ? ', ' : ''}{item}</span>) : "N.A"}</div>
                                </Grid>}
                            {props.module === "group-room" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Check In Date </div>
                                    <div className='row-summary-value'>{row.scheduledStartTime ? `${dayjs(row.scheduledStartTime).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.scheduledStartTime).utc().format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                                </Grid>}
                                {props.module === "group-room" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Check Out Date </div>
                                    <div className='row-summary-value'>{row.scheduledEndTime ? `${dayjs(row.scheduledEndTime).format(GlobalProps.dateTimeFormat) !== "Invalid date" && dayjs(row.scheduledEndTime).utc().format(GlobalProps.dateTimeFormat)}` : "N.A"}</div>
                                </Grid>}
                                {props.module === "hotel-config" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Email</div>
                                    <div className='row-summary-value'>{row.email?row.email: "N.A"}</div>
                                </Grid>}
                            {/* {props.module === "customize-welcome-screen" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Customize Welcome Screen Sequence</div>
                                    <div className='row-summary-value'>{row.sequence===false?'Image -> Video':'Video -> Image'}</div>
                                </Grid>} */}
                            {/* {props.module === "room-config" &&
                                <Grid item xs={4} className="mt-3">
                                    <div className='row-summary-title'>Welcome Message Status</div>
                                    <div className='row-summary-value'>{row.welcomeMessageStatus?.length ?  row.welcomeMessageStatus : "N.A"}</div>
                                </Grid>} */}
                        </Grid>
                    </Grid>
                </Box>
            </Collapse>
        </TableCell>
    </TableRow>
}

export default HotelListSummary;